<template>
  <div>
    <hr class="space-account-deletion">
    <div class="section container">
      <div class="account-deletion-container" :class="brandClass()">
      <div class="delete-account-label" :class="brandClass()" role="button" @keydown="ariaClick" tabindex="0" @click="showFirstPopup">
        <span>{{$t('profile_account_data_profile_deletion_title')}}</span>
      </div>
      <div class="section-sub-header-deletion">
        {{$t("profile_account_data_profile_deletion_subtitle")}}
      </div>
      <!-- <div class="section-sub-header" v-if="linkedAccountsPreventingDeletionList.length">
        {{$t("profile_account_data_linked_services_deletion_linked_account")}}
      </div>
      <ul>
        <li  v-for="(account, index) in linkedAccountsPreventingDeletionList" :key="`linked-account-${index}`">
          {{$t(account.translationKey)}}
        </li>
      </ul> -->
      <OneAlert
        v-if="showPopup"
        :brandClass="brandClass()"
        :title="$t('profile_account_data_deletion_popup_title')"
        :content="$t('profile_account_data_deletion_popup_subtitle')"
        :button_confirm_label="$t('profile_delete_button')"
        :button_cancel_label="$t('profile_cancel_button')"
        @confirm="submit"
        @close="closePopup"
      />
        <OneAlert
        :brandClass="brandClass()"
        v-if="showSecondPopup"
        :title="$t('profile_account_data_deletion_popup_title')"
        :content="isDetailedErrorMessage ? $t('profile_account_data_deletion_popup_subtitle_cic_subscriptions') : $t('profile_account_data_deletion_popup_subtitle_cic')"
        :button_full_label="$t('profile_account_data_deletion_popup_profile_okay_button')"
        @full="closeSecondPopup"
        @close="closeSecondPopup"
      >
        <template v-slot:internal-content v-if="$c('link_contact_us')">
          <br/>
          <a style='font-weight:bold;' @keydown="ariaClick" tabindex='0' href="javascript:void(0)" @click="onContactUsClick()">{{$t('profile_account_data_deletion_popup_subtitle_cic_contactus')}}</a>         </template>
        </OneAlert>
        <OneAlert
        :brandClass="brandClass()"
        v-if="showSuccessPopup"
        :title="$t('profile_account_data_deletion_popup_confirm_title')"
        :subsubtitle="
          $t('profile_account_data_deletion_popup_confirm_subtitle_prefix') + ' ' + timeLeft + ' ' + $t('profile_account_data_deletion_popup_confirm_subtitle_suffix')
        "
        :showCloseButton="false"  
      />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .section-sub-header-deletion {
    margin-top: 22px;
    font-size: 16px;
  }
  .space-account-deletion {
    margin-bottom: 34px;
  }
  .account-deletion-container {
    background:$grey12;
    padding-left: 36px;
    padding-right: 36px;
    padding-top: 30px;
    padding-bottom: 30px;
  
    &.__d {
      color: $black;
    }
  }
  .delete-account-label{
    width: fit-content;
    background-repeat: no-repeat;
    padding-left: 15px;
    &:hover {
      cursor: pointer;
      font-weight: bold;
      text-decoration: underline;
    }
    background-image: url('~@/assets/default/light/edit-default-light.svg');
    font-weight: bold;
    &.__alphabet{
      background-image: url('~@/assets/alphabet/light/edit-alphabet-light.svg');
    }
    &.__m{
      background-image: url('~@/assets/mini/light/arrow-right-mini-light.svg');
       &:hover {
          text-decoration: none;
        }
      span{
        margin-left: 12px;
        font-size: 14px;
        line-height: 13px;
        font-weight: normal;
        font-family: MINISansSerif;
        border-bottom: 1px solid $dusty;
        &:hover {
          font-weight: bold;
          text-decoration: none;
        }
      }
    }
    &.__t{
      &:hover {
          text-decoration: none;
        }
      span{
        margin-left: 12px;
        font-size: 14px;
        line-height: 13px;
        font-weight: normal;
        font-family: ToyotaSemibold;
        border-bottom: 1px solid $dusty;
        &:hover{
          border-bottom: 1px solid $toyotared;
          text-decoration: none;
        } 
      }
    }
  }
</style>
<script>
  import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
  
  export default {
    inject:['$c', '$t', 'brandClass', '$navigateByPath'],
    name: "ProfileAccountDeletion",
    //validations from vuelidate
    props: {
      user: {},
      editDisabled: {
        default: false,
        type: Boolean,
      },
    },
    mixins:[oneUtils.accessibilityMixin],
    data: () => ({
      attemptNumber: 1,
      editMode: false,
      showPopup: false,
      showSecondPopup: false,
      showSuccessPopup: false,
      timeLeft: 10,
      interval: null,
    }),
    computed:{
      linkedAccountsPreventingDeletionList(){
        const toReturn = [];
        if(!this.user.linkedAccounts) return "";
        for (const linked of this.user.linkedAccounts) {
          const linkedAccount = this.$c('list_of_linked_accounts').filter(a=>a.key==linked.type);
          if (linkedAccount && linkedAccount.length){
            toReturn.push(linkedAccount[0].key);
          };
        }
        return toReturn.join(", ");
      },
      isDetailedErrorMessage() {
        const userLinkedAccountKeys = [];

        this.user.linkedAccounts?.forEach(userLinkedAccount => {
          const linkedAccount = this.$c('list_of_linked_accounts').find(linkedAccount => linkedAccount.key == userLinkedAccount.type);

          if(linkedAccount) {
            userLinkedAccountKeys.push(linkedAccount.key);
          };
        });

        let isFound = false;

        userLinkedAccountKeys.forEach(linkedAccountKey => {
          if(oneUtils.properties.LINKED_SERVICES_SHOWING_SUBSCRIPTIONS_DELETE_SUBTITLE.includes(linkedAccountKey)) {
            isFound = true;
          }
        });

        return isFound;
      }
    },
    methods:{
      closePopup(colsedBy){
        this.showPopup=false;
      },
      showFirstPopup(){
        this.showPopup=true;
      },
      closeSecondPopup(){
        this.showSecondPopup=false;
      },
      countdown() {
        this.interval = setInterval(() => {   
          if(this.timeLeft > 1) {
            this.timeLeft = this.timeLeft - 1;
          }  else {
            clearInterval(this.interval);
            oneUtils.utils.showGlobalLoader();
            const sessionLogout = ()=>{
              oneUtils.httpClient
              .sessionLogout(this.$store.getters.configure("key_for_internal_client_id"))
              .then((data) => {
                console.log('session revoke success: ');
                oneUtils.sessionUtils.cleanLocalStorage();
          })
          .catch((e) => {
              console.log('session revoke error: ',e);
              oneUtils.sessionUtils.cleanLocalStorage();
              oneUtils.utils.hideGlobalLoader();
          }).finally(()=>{
            if (window['$startupwebcomponent']){
              const event = new CustomEvent("WEB_COMPONENT_LOGOUT");
              window.dispatchEvent(event);
            }else{
              this.$navigateByPath('login', {redirectFrom:'profile'});
            }
          });
        }
        oneUtils.httpClient.tokenLogout(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then(() => {
            sessionLogout();
          })
          .catch((e) => {
            sessionLogout();
          });
          } 
        }, 1000);
      },
      onContactUsClick() {
        window.open(this.$c('link_contact_us'),'_blank','noopener');
      },
      submit(){
        this.attemptNumber++;
        this.showPopup=false;
        oneUtils.utils.showGlobalLoader();
        oneUtils.httpClient.deleteAccount(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then((res) => {
          if(res.data && res.data.accountDeleted){
            oneUtils.utils.hideGlobalLoader();
            this.showSuccessPopup=true;
            this.countdown();
          }else if(res.data && res.data.accountNotDeletedReason){
            this.showSecondPopup=true;
            oneUtils.utils.hideGlobalLoader();
          }else{
            oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
            oneUtils.utils.hideGlobalLoader();
          }
        })
        .catch((e) => {
          oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
          oneUtils.utils.hideGlobalLoader();
        });
        
      }
    }
  };
</script>